import React from 'react';
import { Button, Card, Input, List, Modal, Select, Space, Typography } from 'antd';
import { formatDate } from 'utils/date';

const { Text } = Typography;

const Mobile = ({ viewModel }) => {
  const {
    filteredData,
    keyword,
    onKeywordChange,
    packageFilter,
    onPackageFilterChange,
    expiryFilter,
    onExpiryFilterChange,
    getPackageName,
    openRenewModal,
    renewTarget,
    packages,
    renewPackageKey,
    setRenewPackageKey,
    renewDuration,
    setRenewDuration,
    renewSubmitting,
    closeRenewModal,
    submitRenew,
  } = viewModel;

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      <Input
        size='middle'
        placeholder='Tìm shop / chủ shop / SĐT'
        allowClear
        value={keyword}
        onChange={onKeywordChange}
      />

      <Select value={expiryFilter} style={{ width: '100%' }} onChange={onExpiryFilterChange}>
        <Select.Option value='all'>Tất cả hạn dùng</Select.Option>
        <Select.Option value='expiring_7d'>Sắp hết hạn (7 ngày)</Select.Option>
      </Select>

      <Select value={packageFilter} style={{ width: '100%' }} onChange={onPackageFilterChange}>
        <Select.Option value='all'>Tất cả gói</Select.Option>
        {(packages || []).map((item) => (
          <Select.Option key={item.key} value={item.key}>{item.name}</Select.Option>
        ))}
      </Select>

      <List
        dataSource={filteredData || []}
        locale={{ emptyText: 'Chưa có shop' }}
        renderItem={(record) => (
          <List.Item style={{ padding: 0, border: 'none' }}>
            <Card
              size='small'
              style={{ width: '100%', marginBottom: 12 }}
              bodyStyle={{ padding: 12 }}
            >
              <Space direction='vertical' size={6} style={{ width: '100%' }}>
                <Space style={{ justifyContent: 'space-between', width: '100%' }}>
                  <Text strong>{record?.web_site?.title || '-'}</Text>
                  <a href={`https://${record?.web_site?.url}.sipro.store`} target='_blank' rel='noreferrer'>Xem</a>
                </Space>

                <Text type='secondary'>Tạo lúc: {formatDate(record?.create_on)}</Text>
                <Text>Gói cước: {getPackageName(record)}</Text>
                <Text type='secondary'>Hết hạn: {formatDate(record?.subscription?.expiry_on) || '-'}</Text>

                <Space direction='vertical' size={0} style={{ width: '100%' }}>
                  <Text>{record?.owner?.full_name || '-'}</Text>
                  <Text type='secondary'>{record?.owner?.phone || '-'}</Text>
                </Space>

                <Space size={12} wrap>
                  <Text>Sản phẩm: {record?.product_count || 0}</Text>
                  <Text>Đơn tháng này: {record?.order_count_month || 0}</Text>
                </Space>

                <Button onClick={() => openRenewModal(record)}>Gia hạn</Button>
              </Space>
            </Card>
          </List.Item>
        )}
      />

      <Modal
        title='Gia hạn gói cước'
        open={!!renewTarget}
        onCancel={closeRenewModal}
        onOk={submitRenew}
        okText='Xác nhận gia hạn'
        cancelText='Đóng'
        confirmLoading={renewSubmitting}
      >
        <Space direction='vertical' style={{ width: '100%' }}>
          <div>Shop: {renewTarget?.web_site?.title || '-'}</div>
          <div>
            <label>Gói cước</label>
            <Select value={renewPackageKey} style={{ width: '100%' }} onChange={setRenewPackageKey}>
              {(packages || []).map((item) => (
                <Select.Option key={item.key} value={item.key}>{item.name}</Select.Option>
              ))}
            </Select>
          </div>
          <div>
            <label>Số tháng</label>
            <Select value={renewDuration} style={{ width: '100%' }} onChange={setRenewDuration}>
              <Select.Option value={1}>1 tháng</Select.Option>
              <Select.Option value={3}>3 tháng</Select.Option>
              <Select.Option value={6}>6 tháng</Select.Option>
            </Select>
          </div>
        </Space>
      </Modal>
    </div>
  );
};

export default Mobile;